// Smell similarity chain

var selectedCollections = {};
var fragrancesData = {};

const smellChain = ["woody", "earthy", "smoky", "oriental", "spicy", "warm", "sweet", "fruity", "floral", "citrusy", "fresh", "musky"];
const genders = document.querySelector(".genders");
const fragrances = document.querySelector(".fragrances");

window.onload = () => {
    fetch('https://cdn.shopify.com/s/files/1/0012/9980/8330/files/Smells.json')
        .then((response) => response.json())
        .then((json) => {
            fragrancesData = json;

            fragrancesData["Sheet1"].forEach(fragrance => {
                fragrance.score = calculateScore(fragrance['smell'].split(", "))
            })
        });
};

function submitAnswer(step, element) {
    switch (step) {
        case "1":
            navigateSteps('.quiz-intro', ".quiz-step-1")
            break;

        case "2":
            genders.innerHTML = `
            <a onclick='return goBack(".quiz-step-1", ".quiz-step-2")' class="back-btn text-14 text-center block mb-8 cursor-pointer">← Back</a>
            <div class="text-20 font-bold text-center mb-12">What Type Of Scent Are You Interested In?</div>
            <div class="grid grid-cols-1 gap-6 max-w-md mx-auto"></div>`
            const collectionsData = element.getAttribute("data-collections");


            collectionsData.split(",").map((collection, index) => {
                if (collection !== "") {
                    var gender;
                    if (index == 0) {
                        gender = "Masculine";
                    }
                    else if (index == 1) {
                        gender = "Feminine";
                    }
                    else {
                        gender = "Unisex";
                    }

                    genders.querySelector('div:last-child').innerHTML += `<a onclick='return selectCollections("${collection}")' data-collections="${collection}"
                        class="single-collection border-[1px] border-primary rounded-[8px] py-4 px-8 text-center max-w-[320px] hover:bg-primary hover:text-white transition-colors">
                        ${gender}</a>`
                }
            });

            genders.querySelector('div:last-child').innerHTML += `<a onclick='return selectCollections("${collectionsData}")' 
                class="border-[1px] border-primary rounded-[8px] py-4 px-8 text-center max-w-[320px] hover:bg-primary hover:text-white transition-colors">
                Open To Anything</a>
            </div>`


            if (document.querySelectorAll(".single-collection").length < 2) {
                selectedCollections = document.querySelector(".single-collection").getAttribute("data-collections").split(",");
                navigateSteps('.quiz-step-1', ".quiz-step-3")
            }
            else {
                navigateSteps('.quiz-step-1', ".quiz-step-2")
            }
            break;

        case "4":
            navigateSteps('.quiz-step-3', ".quiz-step-4")
            break;

        case "5a":
            fragrances.innerHTML = '';

            // Guard: Check if fragrance data is loaded
            if (!(fragrancesData && fragrancesData["Sheet1"])) {
                fragrances.innerHTML = '<div class="no-data text-center text-16">No fragrance data loaded. Please try again later.</div>';
                return false;
            }

            // Render all fragrance items
            fragrancesData["Sheet1"].forEach(fragrance => {
                fragrances.innerHTML += `
                    <div class="fragrance col-span-2 md:col-span-5 border-[1px] border-primary text-12 rounded-[8px] 
                        aspect-[5/4] bg-[#f9f6e7] flex flex-col justify-center items-center p-4 hover:shadow-sm transition-shadow"
                        data-smell="${fragrance['smell']}"
                        data-score="${fragrance['score']}"
                        data-gender="${fragrance['gender']}"
                        data-strength="${fragrance['strength']}">
                        <div class="fragrance-name text-16 text-center font-bold leading-tight h-36 mb-2">
                            ${fragrance["Name"]}
                        </div>
                        <a class="primary-btn text-14 px-16 py-2 hover:bg-primary hover:text-white transition-colors" 
                            onclick='return selectFragrance(this)'>Select</a>
                    </div>
                `;
            });

            // Attach search feature on quiz-step-5a
            const searchInput = document.querySelector('.quiz-search-input');
            if (searchInput) {
                searchInput.addEventListener('input', function() {
                    const searchText = this.value.toLowerCase();
                    const fragranceElements = fragrances.querySelectorAll('.fragrance');
                    
                    fragranceElements.forEach(element => {
                        const fragranceName = element.querySelector('.fragrance-name').textContent.toLowerCase();
                        if (fragranceName.includes(searchText)) {
                            element.style.display = 'flex';
                        } else {
                            element.style.display = 'none';
                        }
                    });
                });
            }

            navigateSteps('.quiz-step-4', ".quiz-step-5a");
            break;

        case "6a":
            navigateSteps('.quiz-step-5a', ".quiz-step-6a")
            break;

        case "7a":
            var selectedSmells = [];
            var selectedFragrances = fragrances.querySelectorAll("a:not(.primary-btn)");
            selectedFragrances.forEach(smell => {
                var fragranceSmells = smell.parentNode.dataset.smell.split(", ");
                selectedSmells.push(...fragranceSmells)
            })

            const fragrancesByScore = Object.entries(sortAnglesByCloseness(calculateScore(selectedSmells)));
            console.log("*****")
            console.log(selectedSmells)
            console.log(calculateScore(selectedSmells))

            // Log the original ordered fragrances
            console.log("Original ordered fragrances:", fragrancesByScore);

            // If the clicked element contains "different", reverse the order
            if (element.textContent.trim().includes("different")) {
                fragrancesByScore.reverse();
                // Log the reversed fragrances
                console.log("Reversed fragrances:", fragrancesByScore);
            }

            document.querySelector('.quiz-step-results').dataset.path = 'a';
            fetchProducts(fragrancesByScore, 'a');
            break;

        case "5b":
            navigateSteps('.quiz-step-4', ".quiz-step-5b")
            break;

        case "6b":
            // Disable liked smells in disliked section before showing it
            const likedSmells = document.querySelectorAll('.quiz-step-5b .selected');
            const allDislikedOptions = document.querySelectorAll('.quiz-step-6b .smell-slot');

            allDislikedOptions.forEach(option => {
                const smell = option.dataset.smell;
                const isLiked = Array.from(likedSmells).some(div => div.dataset.smell === smell);
                if (isLiked) {
                    option.classList.add("opacity-50", "pointer-events-none");
                    option.style.cursor = "not-allowed";
                } else {
                    option.style.cursor = "pointer";
                }
            });

            navigateSteps('.quiz-step-5b', ".quiz-step-6b")
            break;

        case "7b":
            navigateSteps('.quiz-step-6b', ".quiz-step-7b")
            break;

        case "8b":
            var selectedSmells = [];
            document.querySelectorAll('.quiz-step-5b .selected').forEach(div => {
                selectedSmells.push(div.dataset.smell);
            });

            const smellBasedFragrances = Object.entries(sortAnglesByCloseness(calculateScore(selectedSmells)));
            const selectedStrength = element.textContent.trim().toLowerCase();

            document.querySelector('.quiz-step-results').dataset.path = 'b';
            fetchProducts(smellBasedFragrances, 'b', selectedStrength);
            break;

        default:
        // code block
    }
}

function navigateSteps(from, to) {
    $(from).fadeOut(500).promise().done(function () {
        $(to).fadeIn(1000);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

function selectCollections(collection) {
    selectedCollections = collection.split(",");
    navigateSteps('.quiz-step-2', ".quiz-step-3")
}

function selectFragrance(element) {
    const nextButton = document.querySelector(".quiz-step-5a a.sticky");

    element.classList.toggle("primary-btn");
    element.innerHTML = element.classList.contains('primary-btn') ? "Select" : "Remove";

    var selectedFragrances = fragrances.querySelectorAll("a:not(.primary-btn)");
    var notSelectedFragrances = fragrances.querySelectorAll("a.primary-btn");

    if (selectedFragrances.length < 2) {
        if (selectedFragrances.length == 0) {
            nextButton.classList.add("hidden")
        }
        else {
            nextButton.classList.remove("hidden")
            notSelectedFragrances.forEach(fragrance => {
                fragrance.classList.remove(...["opacity-50", "pointer-events-none"])
            })
        }
    }
    else {
        nextButton.classList.remove("hidden")
        notSelectedFragrances.forEach(fragrance => {
            fragrance.classList.add(...["opacity-50", "pointer-events-none"])
        })
    }
}

function fetchProducts(fragrances, path, strength = null) {
    console.log(fragrances)
    const results = document.querySelector(".quiz-step-results");

    results.innerHTML = `
        <a onclick='return goBack(".quiz-step-6a", ".quiz-step-results")' class="back-btn text-14 text-center block mb-8 cursor-pointer">← Back</a>
        <div class="text-20 font-bold text-center mb-8">Here are your matches:</div>
        <div class="grid grid-cols-2 gap-6 max-w-2xl mx-auto">
    `;
    let productCount = 0;

    // Get disliked smells from step 5b (only for "-b" path)
    const dislikedSmells = path === 'b' ? Array.from(document.querySelectorAll('.quiz-step-6b .selected') || [])
        .map(div => div.dataset.smell.toLowerCase()) : [];

    selectedCollections.forEach(collection => {
        if (collection !== "" && productCount < 4) {
            fetch("/?view=collection&handle=" + collection)
                .then(res => res.text())
                .then(html => {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
                    var products = doc.querySelectorAll('.product-data');

                    fragrances.forEach(fragrance => {
                        if (productCount < 4) {
                            // Skip products that contain any disliked smells (only for "-b" path)
                            const fragranceSmells = fragrance[1]["smell"].toLowerCase().split(", ");
                            const hasDislikedSmell = path === 'b' && dislikedSmells.some(smell =>
                                fragranceSmells.includes(smell.toLowerCase())
                            );

                            // Check if fragrance matches selected strength
                            const matchesStrength = !strength || fragrance[1]["strength"].toLowerCase() === strength;

                            if (!hasDislikedSmell && matchesStrength) {
                                products.forEach(product => {
                                    if (fragrance[1]["Name"].toLowerCase() == product.innerHTML.trim()) {
                                        results.querySelector('.grid').innerHTML += `
                                            <div class="result-product border-[1px] border-primary rounded-[8px]  text-center">
                                                <img src="${product.dataset.productImage}" class="w-full aspect-square  rounded-t-[8px] object-cover mb-4">
                                                <div class="p-8">
                                                    <div class="full-unstyled-link line-clamp-2 text-14 md:text-12 font-bold uppercase  mb-8 h-40" data-product-id="${product.dataset.productId}">
                                                        ${product.dataset.productTitle}
                                                    </div>
                                                    <a href="/products/${product.dataset.productHandle}" target="_blank" class="primary-btn text-14 px-12 py-4">View Product</a>
                                                </div>
                                            </div>
                                        `;
                                        productCount++;
                                    }
                                });
                            }
                        }
                    });

                    // Navigate to results step after products are loaded and hide appropriate step
                    if (path === 'a') {
                        navigateSteps('.quiz-step-6a', ".quiz-step-results");
                    } else {
                        navigateSteps('.quiz-step-7b', ".quiz-step-results");
                    }
                });
        }
    });
}

function sortAnglesByCloseness(inputAngle) {
    function circularDifference(a, b) {
        let diff = Math.abs(a - b);
        return Math.min(diff, 360 - diff);
    }

    return fragrancesData["Sheet1"].sort((a, b) => {
        return circularDifference(inputAngle, a.score) - circularDifference(inputAngle, b.score);
    });
}

function calculateScore(smells) {
    var score = 0;
    var smellsCount = 0;
    smells.map(element => {
        var smell = element.replace(',', '').replace(' ', '').toLowerCase();
        if (smell != "") {
            smellIndex = smellChain.indexOf(smell) + 1
            if (smellIndex > 0) {
                smellsCount++
                score += smellIndex;
            }
        }
    });

    return score * 30 / smellsCount
}

function selectSmell(element) {
    // Determine which section we're in (liked or disliked)
    const container = element.closest('.liked-smells, .disliked-smells');
    const nextButton = container.classList.contains('liked-smells')
        ? document.querySelector(".quiz-step-5b a.primary-btn")
        : document.querySelector(".quiz-step-6b a.primary-btn");

    // If we're in disliked smells section, check if this smell was liked
    if (container.classList.contains('disliked-smells')) {
        const smell = element.dataset.smell;
        const likedSmells = document.querySelectorAll('.liked-smells .selected');
        const isLiked = Array.from(likedSmells).some(div => div.dataset.smell === smell);
        if (isLiked) {
            return false;
        }
    }

    // Toggle selected class on the div
    element.classList.toggle("selected");

    // Get selected and not selected smells within the current section
    const selectedSmells = container.querySelectorAll('.smell-slot.selected');
    const notSelectedSmells = container.querySelectorAll('.smell-slot:not(.selected)');

    // Show next button if at least one smell is selected
    if (selectedSmells.length > 0) {
        nextButton.classList.add("block");
        nextButton.classList.remove("hidden");
    } else {
        nextButton.classList.remove("block");
        nextButton.classList.add("hidden");
    }

    // Handle smell slot states
    if (container.classList.contains('disliked-smells')) {
        // Get liked smells to maintain their disabled state
        const likedSmells = document.querySelectorAll('.liked-smells .selected');

        // First, remove disabled state from all non-selected smells
        notSelectedSmells.forEach(smell => {
            const isLiked = Array.from(likedSmells).some(div => div.dataset.smell === smell.dataset.smell);

            // Only remove disabled state if it's not a liked smell
            if (!isLiked) {
                smell.classList.remove("opacity-50", "pointer-events-none");
                smell.style.cursor = "pointer";
            } else {
                smell.style.cursor = "not-allowed";
            }
        });

        // Then, if we have 3 selected, disable all non-selected (except already disabled liked smells)
        if (selectedSmells.length === 3) {
            notSelectedSmells.forEach(smell => {
                smell.classList.add("opacity-50", "pointer-events-none");
                smell.style.cursor = "not-allowed";
            });
        }
    } else {
        // For liked smells section, handle normally
        if (selectedSmells.length === 3) {
            notSelectedSmells.forEach(smell => {
                smell.classList.add("opacity-50", "pointer-events-none");
                smell.style.cursor = "not-allowed";
            });
        } else {
            notSelectedSmells.forEach(smell => {
                smell.classList.remove("opacity-50", "pointer-events-none");
                smell.style.cursor = "pointer";
            });
        }
    }

    return false;
}

function goBack(fromStep, currentStep) {
    // Reset selections if current step is quiz-step-5a: clear fragrance selections and reset next button
    if (currentStep === '.quiz-step-5a') {
        document.querySelectorAll('.quiz-step-5a a:not(.sticky)').forEach(btn => {
            if (btn.classList.contains('primary-btn')) {
                btn.classList.remove('primary-btn');
                btn.innerHTML = "Select";
            }
        });
        document.querySelectorAll('.quiz-step-5a .opacity-50').forEach(el => {
            el.classList.remove('opacity-50', 'pointer-events-none');
            el.style.cursor = 'pointer';
        });
        const nextButton = document.querySelector('.quiz-step-5a a.sticky');
        if (nextButton) {
            nextButton.classList.add('hidden');
            nextButton.classList.remove('block');
        }
    }

    // Reset selections if current step is quiz-step-2: clear selected collections and reset genders content
    if (currentStep === '.quiz-step-2') {
        selectedCollections = {};
        const gendersContainer = document.querySelector('.genders');
        if (gendersContainer) {
            gendersContainer.innerHTML = `
            <a onclick='return goBack(".quiz-step-1", ".quiz-step-2")' class="back-btn text-14 text-center block mb-8 cursor-pointer">← Back</a>
            <div class="text-20 font-bold text-center mb-12">What Type Of Scent Are You Interested In?</div>
            \n<div class="grid grid-cols-1 gap-6 max-w-md mx-auto"></div>`;
        }
    }

    // Reset smell selections for quiz-step-5b and quiz-step-6b
    if (currentStep === '.quiz-step-5b' || currentStep === '.quiz-step-6b') {
        const container = currentStep === '.quiz-step-5b' ? '.liked-smells' : '.disliked-smells';

        document.querySelectorAll(`${container} .selected`).forEach(smell => {
            smell.classList.remove('selected');
        });

        document.querySelectorAll(`${container} .smell-slot`).forEach(smell => {
            smell.classList.remove('opacity-50', 'pointer-events-none');
            smell.style.cursor = 'pointer';
        });

        const nextButton = document.querySelector(`${currentStep} a.sticky`);
        if (nextButton) {
            nextButton.classList.add('hidden');
            nextButton.classList.remove('block');
        }
    }

    // Handle results back navigation
    if (currentStep === '.quiz-step-results') {
        const path = document.querySelector('.quiz-step-results').dataset.path;
        fromStep = path === 'a' ? '.quiz-step-6a' : '.quiz-step-7b';
    }

    $(currentStep).fadeOut(500).promise().done(function () {
        $(fromStep).fadeIn(1000);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    return false;
}
